import React, { useEffect, useState, useRef, useCallback, useMemo, useLayoutEffect } from 'react';
import { apis, apiHolder as api, addDingTalkSearchStringToUrl, } from 'api';
import { useResizeDetector } from 'react-resize-detector';
import { usePopper } from 'react-popper';
import classNames from 'classnames';
import { isMainAccount } from '@web-mail/util';
import Loadable from '@loadable/component';
const TaskMailCard = Loadable(() => import('../../TaskMailCard/TaskMailCard'));
const PraiseMedalItem = Loadable(() => import('../../PraiseMedal'));
const IcsCard = Loadable(() => import('../../IcsCard'));
setTimeout(() => {
    IcsCard.preload();
}, 20 * 1000);
import ImgPreview from '@web-common/components/UI/ImagePreview';
import readWrapper, { downloadImg, handleCopyImg, randomName, parseUrlParams } from '../util';
import { useActions, useAppSelector, ReadMailActions } from '@web-common/state/createStore';
import { copyText } from '@web-common/components/UI/ContextMenu/util';
import LxPopover from '@web-common/components/UI/LxPopover/LxPopover';
import ContactDetail from '@web-contact/component/Detail/detail';
import { SingleMailLoading } from '../component/Loadings';
import { urlHasJavascriptProtocol, isTextShortcut } from '../../../util';
import throttle from 'lodash/throttle';
import useCreateCallbackForEvent from '../../../hooks/useCreateCallbackForEvent';
import useDebounceForEvent from '../../../hooks/useDebounceForEvent';
import useGetTagHotkeys from '../hooks/useGetTagHotkeys';
import useStateRef from '@web-mail/hooks/useStateRef';
import useThrottleForEvent from '@web-mail/hooks/useThrottleForEvent';
import { loadScript } from '@web-common/utils/utils';
import Toast from '@web-common/components/UI/Message/SiriusMessage';
import { useRiskLinkModal } from '@web-common/hooks/useRiskLinkModal';
import { buildLinkUrl } from '@web-common/utils/safeBrowsing';
import SafeBrowsingModal from '../../SafeBrowsingModal';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const loggerApi = api.api.requireLogicalApi(apis.loggerApiImpl);
const safeBrowsingApi = api.api.requireLogicalApi(apis.safeBrowsingApiImpl);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const systemApi = api.api.getSystemApi();
const performance = api.api.requireLogicalApi(apis.performanceImpl);
const virtualReference = {
    getBoundingClientRect() {
        return {
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            width: 0,
            height: 0,
        };
    },
};
const isTag = (target, tagName) => {
    return target.tagName && target.tagName.toLowerCase() === tagName;
};
const MailContent = React.forwardRef((props, ref) => {
    var _a, _b, _c, _d, _e;
    const { icsMail, icsProps, content, merge, isrcl, mailIdChangeRecord, readOnly, forceUpdate, onIframeSizeChange, onIframeScroll, freezeMouse = false } = props;
    const frameRef = useRef(null);
    const { width = 500, ref: mailReaderWrap } = useResizeDetector();
    const [popperHidden, setPopperHidden] = useState(true);
    const popperElement = useRef(null);
    const { styles, attributes, update } = usePopper(virtualReference, popperElement.current, { placement: 'right-start' });
    const iframeSelectionTextRef = useRef();
    const [contactPos, setContactPos] = useState({
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
    });
    const [contactCardVisible, setContactCardVisible] = useState(false);
    const [contactClicked, setContactClicked] = useState();
    const [clickEmail, setClickEmail] = useState('');
    const reduxReplyExpandedId = useAppSelector(state => state.mailReducer.replyExpandedId);
    const replyExpandedId = useRef(reduxReplyExpandedId);
    const [medalHoverShow, setMedalHoverShow] = useState(false);
    const [medalData, setMedalMedalData] = useState(null);
    const [medalHoverPos, setMedalHoverPos] = useState({
        top: 0,
        left: 0,
    });
    const [praiseOwner, setPraiseOwner] = useState(false);
    const { updateTaskDetail } = useActions(ReadMailActions);
    const [fadeIn, setFadeIn] = useState(true);
    const { setRiskUrl, RiskLinkNotificationModal } = useRiskLinkModal();
    const [safeBrowsingState, setSafeBrowsingState] = useState({ visible: false, targetUrl: '', remainCnt: 0, loading: false });
    const safeBrowsingTokenRef = useRef(0);
    const debounceSetFadeIn = useDebounceForEvent(setFadeIn, 150);
    const tagHotkeyMap = useGetTagHotkeys(content === null || content === void 0 ? void 0 : content._account);
    const tagHotkeyMapRef = useStateRef(tagHotkeyMap);
    const getBoundingClientRectFromIframe = useCallback((el, iframe) => {
        const elRect = el.getBoundingClientRect();
        const iframeRect = iframe.getBoundingClientRect();
        const { clientWidth } = document.body;
        const { clientHeight } = document.body;
        return {
            top: elRect.top + iframeRect.top,
            right: clientWidth - (elRect.right + iframeRect.left),
            bottom: clientHeight - (elRect.bottom + iframeRect.top),
            left: elRect.left + iframeRect.left,
        };
    }, []);
    useEffect(() => {
        var _a, _b, _c, _d;
        if (((_b = (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.content) == '' || ((_d = (_c = content === null || content === void 0 ? void 0 : content.entry) === null || _c === void 0 ? void 0 : _c.content) === null || _d === void 0 ? void 0 : _d.content) == null) {
            debounceSetFadeIn(false);
        }
        else {
            debounceSetFadeIn(true);
        }
    }, [(_b = (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.content]);
    useEffect(() => {
        if (popperHidden) {
            iframeSelectionTextRef.current = '';
        }
    }, [popperHidden]);
    useEffect(() => {
        replyExpandedId.current = reduxReplyExpandedId;
    }, [reduxReplyExpandedId]);
    useEffect(() => {
        if (content && !content.taskId) {
            updateTaskDetail({});
        }
    }, [content === null || content === void 0 ? void 0 : content.id]);
    const onIframeContextMenu = useCallback(contextMenu => {
        if (contextMenu) {
            switch (contextMenu.type) {
                case 'copyImg':
                    if (contextMenu.copyImgSrc) {
                        handleCopyImg(undefined, contextMenu.copyImgSrc);
                    }
                    break;
                case 'downImg':
                    if (contextMenu.downImgSrc) {
                        downloadImg(contextMenu.downImgSrc, '', contextMenu.downImgFid, contextMenu.downImgOriginUrl);
                    }
                    break;
                case 'copyLink':
                    if (contextMenu.copyLinkHref) {
                        copyText(contextMenu.copyLinkHref.replace(/^mailto:/, ''));
                    }
                    break;
                case 'copySelection':
                    copyText(contextMenu.copySelectionText);
                    break;
                default:
                    break;
            }
        }
        const event = document.createEvent('MouseEvents');
        const event2 = document.createEvent('MouseEvents');
        event.initMouseEvent('mousedown', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        event2.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        document.body.dispatchEvent(event);
        document.body.dispatchEvent(event2);
        mailReaderWrap.current.click();
    }, []);
    const onIframeContextMenuRef = useCreateCallbackForEvent(onIframeContextMenu);
    const clickContent = useCallback(e => {
        const { target } = e;
        const mobileDom = isTag(target, 'a') && target.className === 'divNeteaseSiriusATContact';
        const deskDom = isTag(target, 'span') && target.getAttribute('data-mce-contact');
        if ((mobileDom || deskDom) && !readOnly) {
            e.preventDefault();
            const pos = getBoundingClientRectFromIframe(target, frameRef.current);
            const offsetX = target.clientWidth + 5;
            pos.left += offsetX;
            let contactId = target.getAttribute('data-mce-contact-id');
            let contactType = target.getAttribute('data-mce-contact-type');
            if (!contactType) {
                contactId = target.getAttribute('mail-address');
                contactType = 'EMAIL';
            }
            const name = target.textContent.substr(1);
            const newContact = mailApi.buildRawContactItem({
                item: contactId,
                email: contactId,
                type: '',
                name: name || contactId,
            });
            setClickEmail(contactId);
            setContactClicked(newContact.contact);
            setContactCardVisible(true);
            setContactPos(pos);
            const hubbleEventId = target.getAttribute('data-hubble-event-id');
            if (hubbleEventId) {
                trackApi.track(hubbleEventId);
            }
        }
        if (!mobileDom && !deskDom) {
            throttleHandleIframeMouseEvnet();
        }
    }, [readOnly, getBoundingClientRectFromIframe, setRiskUrl]);
    useEffect(() => {
        update && update();
    }, [virtualReference.getBoundingClientRect]);
    const setHiddenCb = () => setPopperHidden(!0);
    useEffect(() => {
        window.addEventListener('click', setHiddenCb);
        return () => {
            window.removeEventListener('click', setHiddenCb);
        };
    }, []);
    React.useImperativeHandle(ref, () => ({
        getIframeRef: () => frameRef,
    }), [frameRef.current]);
    const resetIframeSize = useCallback((setMinWidth) => {
        var _a;
        if ((_a = frameRef.current) === null || _a === void 0 ? void 0 : _a.contentDocument) {
            const doc = frameRef.current.contentDocument;
            const bodyElements = doc.getElementsByTagName('body');
            const realCont = (bodyElements === null || bodyElements === void 0 ? void 0 : bodyElements.length) ? bodyElements[0] : null;
            let contentHeight = (realCont === null || realCont === void 0 ? void 0 : realCont.scrollHeight) || 0;
            frameRef.current.style.height = contentHeight ? contentHeight + 2 + 'px' : 'auto';
            if (realCont) {
                onIframeSizeChange &&
                    onIframeSizeChange({
                        contentScrollWidth: realCont.scrollWidth || 0,
                        constentScrollHeight: realCont.scrollHeight || 0,
                        constentClientWidth: realCont.clientWidth || 0,
                        contentClientHeight: realCont.clientHeight || 0,
                        iframeClientWidth: frameRef.current.clientWidth || 0,
                        iframeClientHeight: frameRef.current.clientHeight || 0,
                    });
            }
        }
    }, [frameRef, onIframeSizeChange]);
    const throttleResetIframeSize = useCallback(throttle(resetIframeSize, 800), [resetIframeSize]);
    const mailLoadOver = useCreateCallbackForEvent(() => {
        var _a, _b;
        try {
            performance.timeEnd({
                statKey: 'mail_readmail_switch',
                statSubKey: '',
                params: {
                    mailId: content === null || content === void 0 ? void 0 : content.id,
                    accountId: content === null || content === void 0 ? void 0 : content._account,
                    threadId: ((_a = mailIdChangeRecord === null || mailIdChangeRecord === void 0 ? void 0 : mailIdChangeRecord.current) === null || _a === void 0 ? void 0 : _a.id) == (content === null || content === void 0 ? void 0 : content.id) ? null : (_b = mailIdChangeRecord === null || mailIdChangeRecord === void 0 ? void 0 : mailIdChangeRecord.current) === null || _b === void 0 ? void 0 : _b.id,
                },
            });
        }
        catch (e) {
            console.error(e);
        }
    });
    const autosizeIframe = useCallback(() => {
        throttleResetIframeSize(true);
    }, []);
    const handlePraise = useCallback(async () => {
        var _a, _b, _c, _d;
        const praiseMedalEl = (_d = (_c = (_b = (_a = frameRef === null || frameRef === void 0 ? void 0 : frameRef.current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.document) === null || _c === void 0 ? void 0 : _c.body) === null || _d === void 0 ? void 0 : _d.querySelector('.praise-medal');
        if (!praiseMedalEl) {
            setMedalMedalData(null);
            return;
        }
        const medalData = JSON.parse(praiseMedalEl.getAttribute('data-medal-source') || 'null');
        const hasOwner = praiseMedalEl.getAttribute('data-hasOwner');
        setPraiseOwner(hasOwner === 'true');
        setMedalMedalData(medalData);
        const praiseMedalOver = () => {
            var _a, _b, _c, _d;
            const targetEl = (_d = (_c = (_b = (_a = frameRef === null || frameRef === void 0 ? void 0 : frameRef.current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.document) === null || _c === void 0 ? void 0 : _c.body) === null || _d === void 0 ? void 0 : _d.querySelector('.praise-medal');
            const pos = targetEl.getBoundingClientRect();
            const top = pos.top + targetEl.offsetHeight;
            const left = pos.left + targetEl.offsetWidth;
            setMedalHoverPos({ top, left });
            setMedalHoverShow(true);
        };
        const praiseMedalOut = () => {
            setMedalHoverShow(false);
        };
        praiseMedalEl.addEventListener('mouseover', praiseMedalOver);
        praiseMedalEl.addEventListener('mouseout', praiseMedalOut);
    }, [frameRef]);
    const unsubscribeRmStatus = useRef();
    useEffect(() => {
        return () => {
            if (unsubscribeRmStatus.current) {
                unsubscribeRmStatus.current();
            }
        };
    }, []);
    const handleLoad = useCallback(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
        try {
            if (mailIdChangeRecord && mailIdChangeRecord.current) {
                const { id, time } = mailIdChangeRecord.current || {};
                if (id === content.id) {
                    const countTime = new Date().getTime() - time;
                    performance.point({
                        statKey: 'mail_ui_content_load_time',
                        statSubKey: '',
                        params: { mailid: id },
                        value: countTime,
                        valueType: 1,
                    });
                    mailIdChangeRecord.current = null;
                }
            }
        }
        catch (e) {
            console.error(e);
        }
        try {
            performance.timeEnd({
                statKey: `mail_listclick_content_load_time`,
                statSubKey: content.id + '',
            });
        }
        catch (e) {
            console.error(e);
        }
        var iframeDoc = ((_a = frameRef === null || frameRef === void 0 ? void 0 : frameRef.current) === null || _a === void 0 ? void 0 : _a.contentDocument) || ((_b = frameRef === null || frameRef === void 0 ? void 0 : frameRef.current) === null || _b === void 0 ? void 0 : _b.contentWindow.document);
        if (iframeDoc) {
            iframeDoc.onscroll = handleIframeScroll;
        }
        iframeSelectionTextRef.current = '';
        if ((_c = frameRef.current) === null || _c === void 0 ? void 0 : _c.contentDocument) {
            const doc = frameRef.current.contentDocument;
            resetIframeSize(true);
            const signatureContainer = (_g = (_f = (_e = (_d = frameRef === null || frameRef === void 0 ? void 0 : frameRef.current) === null || _d === void 0 ? void 0 : _d.contentWindow) === null || _e === void 0 ? void 0 : _e.document) === null || _f === void 0 ? void 0 : _f.body) === null || _g === void 0 ? void 0 : _g.querySelector('#lingxi-signature-v2-content');
            const signatureV2 = (_l = (_k = (_j = (_h = frameRef === null || frameRef === void 0 ? void 0 : frameRef.current) === null || _h === void 0 ? void 0 : _h.contentWindow) === null || _j === void 0 ? void 0 : _j.document) === null || _k === void 0 ? void 0 : _k.body) === null || _l === void 0 ? void 0 : _l.querySelector('#lingxi-signature-v2-block');
            const signature = (_q = (_p = (_o = (_m = frameRef === null || frameRef === void 0 ? void 0 : frameRef.current) === null || _m === void 0 ? void 0 : _m.contentWindow) === null || _o === void 0 ? void 0 : _o.document) === null || _p === void 0 ? void 0 : _p.body) === null || _q === void 0 ? void 0 : _q.querySelector('#lingxi-signature-block');
            try {
                const element = (_u = (_t = (_s = (_r = frameRef === null || frameRef === void 0 ? void 0 : frameRef.current) === null || _r === void 0 ? void 0 : _r.contentWindow) === null || _s === void 0 ? void 0 : _s.document) === null || _t === void 0 ? void 0 : _t.body) === null || _u === void 0 ? void 0 : _u.querySelector('#__sirius_rdb_accept_button');
                if (element) {
                    if (!element.classList.contains('active')) {
                        element.classList.add('active');
                        element.innerHTML = '接受远程协助';
                    }
                    const code = (_z = (_y = (_x = (_w = (_v = frameRef === null || frameRef === void 0 ? void 0 : frameRef.current) === null || _v === void 0 ? void 0 : _v.contentWindow) === null || _w === void 0 ? void 0 : _w.document) === null || _x === void 0 ? void 0 : _x.body) === null || _y === void 0 ? void 0 : _y.querySelector('#__sirius_rdb_auth_code')) === null || _z === void 0 ? void 0 : _z.innerHTML;
                    const GLOBAL_LX_REMOTE_DEBUG = '__LX__SNP__GLOBAL_REMOTE_DEBUG__';
                    if (window[GLOBAL_LX_REMOTE_DEBUG]) {
                        if (window[GLOBAL_LX_REMOTE_DEBUG]) {
                            const tools = window[GLOBAL_LX_REMOTE_DEBUG];
                            if (tools.status === 'remote') {
                                element.innerHTML = '结束协助';
                            }
                            else {
                                element.innerHTML = '接受远程协助';
                            }
                        }
                    }
                    element === null || element === void 0 ? void 0 : element.addEventListener('click', () => {
                        if (element.innerHTML == '结束协助') {
                            element.innerHTML = '接受远程协助';
                            if (window[GLOBAL_LX_REMOTE_DEBUG]) {
                                const tools = window[GLOBAL_LX_REMOTE_DEBUG];
                                Toast.success({ content: '远程协助已关闭' });
                                tools.closeRemoteDebug();
                            }
                        }
                        else {
                            Toast.info({ content: '加载中' });
                            loadScript('https://lingxi.office.163.com/rdbstatic/prodinject.v1.0.0.js')
                                .then(() => {
                                var _a;
                                if (window[GLOBAL_LX_REMOTE_DEBUG]) {
                                    const tools = window[GLOBAL_LX_REMOTE_DEBUG];
                                    tools.setConfig({
                                        project: '灵犀办公',
                                        user: (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id,
                                        env: process.env.BUILD_ISEDM ? 'waimao' : 'lingxi',
                                    });
                                    tools
                                        .displayRemoteDebugToolsImplicit(code)
                                        .then(() => {
                                        element.innerHTML = '结束协助';
                                        Toast.success({ content: '远程协助已开启' });
                                        setTimeout(() => {
                                            Toast.success({ content: '可以通过再次点击邮件中的结束按钮，刷新页面或者重启客户端来终止远程协助' });
                                        }, 1000);
                                    })
                                        .catch((e) => {
                                        const message = e.message || '';
                                        Toast.fail(message);
                                    });
                                    if (unsubscribeRmStatus.current) {
                                        unsubscribeRmStatus.current();
                                        unsubscribeRmStatus.current = null;
                                    }
                                    unsubscribeRmStatus.current = tools.on('statusChange', status => {
                                        if (status === 'remote') {
                                            element.innerHTML = '结束协助';
                                        }
                                        else {
                                            element.innerHTML = '接受远程协助';
                                        }
                                    });
                                }
                            })
                                .catch(e => {
                                console.log(e, '快照工具加载失败');
                            });
                        }
                    });
                }
            }
            catch (e) {
                console.log(e);
            }
            const foldEleElement = (_3 = (_2 = (_1 = (_0 = frameRef === null || frameRef === void 0 ? void 0 : frameRef.current) === null || _0 === void 0 ? void 0 : _0.contentWindow) === null || _1 === void 0 ? void 0 : _1.document) === null || _2 === void 0 ? void 0 : _2.body) === null || _3 === void 0 ? void 0 : _3.querySelector('.foldEle');
            if (foldEleElement) {
                foldEleElement === null || foldEleElement === void 0 ? void 0 : foldEleElement.addEventListener('click', () => {
                    throttleResetIframeSize(true);
                });
            }
            const openPreview = () => {
                throttleResetIframeSize(true);
                const previewUrl = signature === null || signature === void 0 ? void 0 : signature.getAttribute('data-href');
                previewUrl && systemApi.openNewWindow(previewUrl);
            };
            const openPreviewV2 = () => {
                const previewUrl = signatureV2 === null || signatureV2 === void 0 ? void 0 : signatureV2.getAttribute('href');
                previewUrl && systemApi.openNewWindow(previewUrl);
            };
            signature === null || signature === void 0 ? void 0 : signature.addEventListener('click', openPreview);
            signatureContainer === null || signatureContainer === void 0 ? void 0 : signatureContainer.addEventListener('click', openPreviewV2);
            handlePraise();
        }
    }, [mailIdChangeRecord, content === null || content === void 0 ? void 0 : content.id, resetIframeSize, handlePraise]);
    useLayoutEffect(() => {
        var _a, _b, _c, _d, _e;
        const contentText = (_b = (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.content;
        if (frameRef.current && contentText) {
            frameRef.current.setAttribute('style', '');
            const doc = frameRef.current.contentDocument;
            if (doc) {
                doc.documentElement.scrollLeft = 0;
            }
            doc === null || doc === void 0 ? void 0 : doc.open();
            doc === null || doc === void 0 ? void 0 : doc.write(readWrapper(contentText));
            doc === null || doc === void 0 ? void 0 : doc.close();
            autosizeIframe();
            (_e = (_d = (_c = frameRef.current) === null || _c === void 0 ? void 0 : _c.contentDocument) === null || _d === void 0 ? void 0 : _d.addEventListener) === null || _e === void 0 ? void 0 : _e.call(_d, 'click', clickContent);
        }
        return () => {
            var _a, _b, _c;
            (_c = (_b = (_a = frameRef.current) === null || _a === void 0 ? void 0 : _a.contentDocument) === null || _b === void 0 ? void 0 : _b.removeEventListener) === null || _c === void 0 ? void 0 : _c.call(_b, 'click', clickContent);
        };
    }, [(_d = (_c = content === null || content === void 0 ? void 0 : content.entry) === null || _c === void 0 ? void 0 : _c.content) === null || _d === void 0 ? void 0 : _d.content, forceUpdate]);
    const praiseMedalMouseLeave = useCallback(() => {
        setMedalHoverShow(false);
    }, []);
    const praiseMedalMouseEnter = useCallback(() => {
        setMedalHoverShow(true);
    }, []);
    const handleIframeScroll = useCallback(() => {
        var _a, _b;
        if (frameRef.current && ((_a = frameRef.current) === null || _a === void 0 ? void 0 : _a.contentDocument)) {
            const scrollLeft = (_b = frameRef.current) === null || _b === void 0 ? void 0 : _b.contentDocument.documentElement.scrollLeft;
            onIframeScroll && onIframeScroll(scrollLeft);
        }
    }, []);
    const renderPraiseMedalHover = useCallback(() => {
        if (medalData) {
            const data = {
                medalData,
                styles: {
                    medalWidth: 142,
                    medalHeight: 142,
                },
                from: 'readMail',
                praiseOwner,
            };
            return (React.createElement("div", { style: Object.assign(Object.assign({}, medalHoverPos), { position: 'absolute', width: 198, boxShadow: '0px 12px 32px rgba(38, 42, 51, 0.12)', background: '#FFFFFF', borderRadius: 8, visibility: medalHoverShow ? 'visible' : 'hidden' }), onMouseLeave: praiseMedalMouseLeave, onMouseEnter: praiseMedalMouseEnter }, medalHoverShow ? React.createElement(PraiseMedalItem, Object.assign({}, data)) : null));
        }
        return null;
    }, [medalData, praiseOwner, medalHoverPos, medalHoverShow, praiseMedalMouseLeave, praiseMedalMouseEnter]);
    const handleIframeImgClick = useCallback(res => {
        const { allImages, startIndex } = res;
        if (allImages && allImages.length) {
            if (!replyExpandedId.current) {
                const data = allImages.map((item) => {
                    return {
                        previewUrl: item.src,
                        downloadUrl: item.src,
                        name: item.alt || randomName(),
                    };
                });
                ImgPreview.preview({
                    data,
                    startIndex,
                });
            }
        }
    }, []);
    const handleIframeLinkClick = useCreateCallbackForEvent(href => {
        if (href) {
            if (href === null || href === void 0 ? void 0 : href.match(/^mailto:/)) {
                const url = href.trim().slice(7);
                let params;
                try {
                    params = parseUrlParams(url);
                }
                catch (e) {
                    params = {
                        path: url.split('?')[0],
                    };
                }
                mailApi.doWriteMailFromLink([params.path], params.subject, params.body, content === null || content === void 0 ? void 0 : content._account);
                trackApi.track('pcMail_click_writeMailButton_topBar', { source: 'Inbox' });
                return;
            }
            if (href.startsWith('https://') || href.startsWith('http://')) {
                runSafeBrowsingFlow(href);
                return;
            }
            if (!urlHasJavascriptProtocol(href)) {
                window.open(window.isInDingTalk ? addDingTalkSearchStringToUrl(href) : href);
            }
        }
    });
    const withTimeout = useCallback((p, ms, fallback) => {
        return new Promise(resolve => {
            let done = false;
            const timer = setTimeout(() => {
                if (done)
                    return;
                done = true;
                resolve(fallback);
            }, ms);
            p.then(v => {
                if (done)
                    return;
                done = true;
                clearTimeout(timer);
                resolve(v);
            }, () => {
                if (done)
                    return;
                done = true;
                clearTimeout(timer);
                resolve(fallback);
            });
        });
    }, []);
    const runSafeBrowsingFlow = useCreateCallbackForEvent((href) => {
        const accountId = accountApi.getEmailIdByEmail((content === null || content === void 0 ? void 0 : content._account) || '');
        if (!isMainAccount(accountId)) {
            setRiskUrl(href);
            return;
        }
        const myToken = ++safeBrowsingTokenRef.current;
        const mid = (content === null || content === void 0 ? void 0 : content.id) ? String(content.id) : undefined;
        withTimeout(safeBrowsingApi.getSbBase(), 800, null).then(base => {
            if (myToken !== safeBrowsingTokenRef.current)
                return;
            const remainCnt = base === null || base === void 0 ? void 0 : base.remainCnt;
            const enabled = Number(base === null || base === void 0 ? void 0 : base.type) > 0;
            if (!enabled) {
                setRiskUrl(href);
                return;
            }
            const checkP = withTimeout(safeBrowsingApi
                .checkUrl({ url: href, mid })
                .then(r => { var _a; return (_a = r === null || r === void 0 ? void 0 : r.riskLevel) !== null && _a !== void 0 ? _a : 0; })
                .catch(() => 0), 800, 0);
            const accessP = withTimeout(safeBrowsingApi
                .getSbAccess({ checkType: 'URL', url: href, mid })
                .then(r => !!(r === null || r === void 0 ? void 0 : r.free))
                .catch(() => false), 800, false);
            Promise.all([checkP, accessP]).then(([riskLevel, free]) => {
                if (myToken !== safeBrowsingTokenRef.current)
                    return;
                if (riskLevel === 0) {
                    window.open(window.isInDingTalk ? addDingTalkSearchStringToUrl(href) : href);
                    return;
                }
                setSafeBrowsingState({
                    visible: true,
                    targetUrl: href,
                    remainCnt,
                    riskLevel,
                    free,
                    loading: false,
                });
            });
        });
    });
    const closeSafeBrowsingModal = useCallback(() => {
        safeBrowsingTokenRef.current += 1;
        setSafeBrowsingState(prev => (Object.assign(Object.assign({}, prev), { visible: false })));
    }, []);
    const onSafeBrowsingNormalOpen = useCallback(() => {
        const url = safeBrowsingState.targetUrl;
        closeSafeBrowsingModal();
        if (url) {
            window.open(window.isInDingTalk ? addDingTalkSearchStringToUrl(url) : url);
        }
    }, [safeBrowsingState.targetUrl, closeSafeBrowsingModal]);
    const onSafeBrowsingSafeOpen = useCallback(() => {
        var _a;
        const url = safeBrowsingState.targetUrl;
        closeSafeBrowsingModal();
        if (url) {
            window.open(buildLinkUrl(url, (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.title));
        }
    }, [safeBrowsingState.targetUrl, closeSafeBrowsingModal, (_e = content === null || content === void 0 ? void 0 : content.entry) === null || _e === void 0 ? void 0 : _e.title]);
    const handleIframeMouseEvnet = useCallback(() => {
        var mouseDownevent = new MouseEvent('mousedown', {
            view: window,
            bubbles: true,
            cancelable: true,
        });
        document.body.dispatchEvent(mouseDownevent);
        var mouseUp = new MouseEvent('mouseup', {
            view: window,
            bubbles: true,
            cancelable: true,
        });
        document.body.dispatchEvent(mouseUp);
        var clickEvent = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true,
        });
        document.body.dispatchEvent(clickEvent);
    }, []);
    const throttleHandleIframeMouseEvnet = useThrottleForEvent(handleIframeMouseEvnet, 300, { leading: true, trailing: false });
    const messageHandlesMap = useMemo(() => {
        return {
            readMail_img_error: value => {
                const subAccount = content === null || content === void 0 ? void 0 : content._account;
                if (value)
                    value._account = subAccount;
                loggerApi.track('read_mail_img_error');
            },
            readMail_attachment_failed: value => {
                loggerApi.track('mail_attachment_check_failed_when_read', value);
            },
            readMail_ContextMenu: value => {
                onIframeContextMenuRef(value);
            },
            readMail_img_click: value => {
                handleIframeImgClick(value);
            },
            readMail_link_click: value => {
                handleIframeLinkClick(value);
            },
            readMail_resizeSize: value => {
                throttleResetIframeSize();
            },
            readMail_mailLoadOver: value => {
                mailLoadOver();
            },
            readMail_keydown: value => {
                window.readMail.keyEvent(value);
                try {
                    const element = document.querySelector('#mailboxhotkey');
                    if (element) {
                        var customEvent = new KeyboardEvent('keydown', value);
                        if (isTextShortcut(customEvent)) {
                            return false;
                        }
                        element.focus();
                        element.dispatchEvent(customEvent);
                        const iframeElement = document.querySelector('#mail-content-iframe');
                        if (iframeElement && (iframeElement === null || iframeElement === void 0 ? void 0 : iframeElement.focus)) {
                            iframeElement.focus();
                        }
                    }
                }
                catch (e) {
                    console.error('[error] readMail_keydown', e);
                }
            },
            update_token: value => {
                mailConfApi.updateAccountTokens({ forceUpdate: true }).then(res => {
                    var _a, _b;
                    if (Array.isArray(res) && frameRef.current && frameRef.current.contentWindow) {
                        const subAccount = content === null || content === void 0 ? void 0 : content._account;
                        const token = (_a = res.find(item => item.account === subAccount)) === null || _a === void 0 ? void 0 : _a.token;
                        const accountSid = (_b = systemApi.getCurrentUser(subAccount)) === null || _b === void 0 ? void 0 : _b.sessionId;
                        frameRef.current.contentWindow.postMessage({ name: 'updateImgToken', data: { token, sid: accountSid || '' } });
                    }
                });
            },
        };
    }, []);
    const handleMessage = useCreateCallbackForEvent(event => {
        var _a;
        if (window.isInDingTalk || ((_a = frameRef.current) === null || _a === void 0 ? void 0 : _a.contentWindow) === (event === null || event === void 0 ? void 0 : event.source)) {
            const { data } = event;
            const { name, value } = data || {};
            if (name && messageHandlesMap[name]) {
                messageHandlesMap[name](value);
            }
        }
    });
    const handlePageClick = useCreateCallbackForEvent(() => {
        if (frameRef.current && frameRef.current.contentWindow) {
            frameRef.current.contentWindow.postMessage('pageClick');
        }
    });
    useEffect(() => {
        window.addEventListener('message', handleMessage);
        window.addEventListener('click', handlePageClick);
        return () => {
            window.removeEventListener('message', handleMessage);
            window.removeEventListener('click', handlePageClick);
        };
    }, []);
    const renderMainContent = useMemo(() => {
        var _a;
        return (React.createElement("div", { ref: mailReaderWrap, className: classNames(['mail-content read-mail-content'], {
                'read-mail-content-merge': merge,
            }), style: { pointerEvents: freezeMouse ? 'none' : 'auto' } },
            React.createElement("iframe", { id: "mail-content-iframe", "data-test-id": "mail-readmail-iframe", ref: frameRef, title: content === null || content === void 0 ? void 0 : content.id, width: "100%", height: "100%", src: "about:blank", frameBorder: "0", onLoad: handleLoad }),
            React.createElement(LxPopover, { top: contactPos.top, left: contactPos.left, right: contactPos.right, bottom: contactPos.bottom, visible: contactCardVisible, setVisible: setContactCardVisible }, contactClicked && (React.createElement(ContactDetail, { email: clickEmail, contact: contactClicked, contactId: (_a = contactClicked === null || contactClicked === void 0 ? void 0 : contactClicked.contact) === null || _a === void 0 ? void 0 : _a.id, dividerLine: false, branch: true, toolipShow: true, _account: content === null || content === void 0 ? void 0 : content._account }))),
            React.createElement(RiskLinkNotificationModal, null),
            React.createElement(SafeBrowsingModal, { visible: safeBrowsingState.visible, targetUrl: safeBrowsingState.targetUrl, remainCnt: safeBrowsingState.remainCnt, riskLevel: safeBrowsingState.riskLevel, free: safeBrowsingState.free, loading: safeBrowsingState.loading, onCancel: closeSafeBrowsingModal, onNormalOpen: onSafeBrowsingNormalOpen, onSafeOpen: onSafeBrowsingSafeOpen }),
            renderPraiseMedalHover()));
    }, [
        handleLoad,
        contactCardVisible,
        contactClicked,
        contactPos,
        clickEmail,
        renderPraiseMedalHover,
        popperHidden,
        styles,
        forceUpdate,
        freezeMouse,
        RiskLinkNotificationModal,
        safeBrowsingState,
        closeSafeBrowsingModal,
        onSafeBrowsingNormalOpen,
        onSafeBrowsingSafeOpen,
    ]);
    const IcsCardElement = useMemo(() => {
        return icsMail ? (React.createElement(IcsCard, { senderEmail: icsProps.senderEmail, setIcsSuccess: icsProps.setIcsSuccess, mid: icsProps.mid, attachmentsIds: icsProps.attachmentsIds })) : (React.createElement(React.Fragment, null));
    }, [icsMail, icsProps]);
    const showTaskOriginEmail = () => {
        if (frameRef && frameRef.current && frameRef.current.contentDocument) {
            const footerEl = frameRef.current.contentDocument.querySelector('.qiyesu-task-footer');
            if (footerEl) {
                footerEl.style.display = 'none';
            }
            const taskEl = frameRef.current.contentDocument.querySelector('.divNeteaseSiriusTask');
            if (taskEl) {
                taskEl.style.display = '';
            }
        }
    };
    const handleTaskMailCardError = () => {
        if (content.taskId) {
            if (frameRef && frameRef.current) {
                showTaskOriginEmail();
            }
            else {
                setTimeout(() => {
                    showTaskOriginEmail();
                }, 30);
            }
        }
    };
    return (React.createElement(React.Fragment, null,
        IcsCardElement,
        (content === null || content === void 0 ? void 0 : content.taskId) ? (React.createElement(TaskMailCard, { mailId: content === null || content === void 0 ? void 0 : content.id, onError: handleTaskMailCardError, todoId: content === null || content === void 0 ? void 0 : content.taskId, isrcl: isrcl, account: content === null || content === void 0 ? void 0 : content._account })) : null,
        React.createElement("div", { className: ` fade-in-out ${fadeIn ? 'fade-in' : 'fade-out'}` }, content ? renderMainContent : React.createElement(SingleMailLoading, null))));
});
export default MailContent;
